import { useTranslation } from 'react-i18next';
import { InfoIcon } from 'lucide-react';
import { formatDateByLanguage } from '~/common/utils/dateUtil';
import { TooltipButton } from '~/common/components/TooltipButton';
import { useSpecialDeliveryDate } from '~/shell/context/specialDeliveryDateContext';

export interface ArticleInfoButtonProps {
  article: {
    mainArticleId: number;
    isProfitPlus: boolean;
    isTransit: boolean;
  };
  reserveSpace?: boolean;
}

export function ArticleInfoButton({ article, reserveSpace = true }: Readonly<ArticleInfoButtonProps>) {
  const { t, i18n } = useTranslation();
  const specialDeliveryDate = useSpecialDeliveryDate(article.mainArticleId);

  if (!article.isProfitPlus && !specialDeliveryDate && !article.isTransit) {
    return reserveSpace ? <div className={'w-[36px]'} /> : null;
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <TooltipButton
        title={t('Zusätzliche Informationen')}
        control={
          <div>
            {specialDeliveryDate && (
              <div data-testid={'next-deliverydate-info'}>
                {t('Frühester Liefertermin')}: {formatDateByLanguage(specialDeliveryDate, i18n.language)}
              </div>
            )}

            {article.isProfitPlus && (
              <div data-testid={'special-info'}>{t('Es gelten spezielle Preis- und Lieferkonditionen!')}</div>
            )}
            {(article.isProfitPlus || specialDeliveryDate || article.isTransit) && (
              <div data-testid={'return-info'}>{t('Kein Rückgaberecht')}</div>
            )}
          </div>
        }
        icon={<InfoIcon size={18} className={'text-primary'} />}
      />
    </div>
  );
}
